// extracted by mini-css-extract-plugin
module.exports = {"Emojis__item":"bff_a bhb_vc bhb_rm bhb_wf"};